export default "__VITE_ASSET__C0F_NGOL__"